import { ReactNode } from 'react';
import ErrorPage from '../components/ErrorPage';
import ProfileSubMenu from '../components/navigation/ProfileSubMenu';
import { reduxServices } from '../reducers/reduxServices';
import { useTypedSelector } from '../stateStore';
import DefaultLayoutV3 from './DefaultLayoutV3';

/**
 * Wrapper-with-children layout. We don't use `<Outlet />` here — route trees
 * compose at the route level (see `ProfileRoutes`) so the layout has a single
 * well-defined contract.
 */
function ProfileLayout({ children }: { children: ReactNode }) {
  const showErrorPage = useTypedSelector(
    reduxServices.globalState.selectors.showErrorPage,
  );

  return (
    <DefaultLayoutV3 navbarElement={<ProfileSubMenu />}>
      <DefaultLayoutV3.Body>
        <DefaultLayoutV3.Content>
          {showErrorPage ? <ErrorPage /> : children}
        </DefaultLayoutV3.Content>
      </DefaultLayoutV3.Body>
    </DefaultLayoutV3>
  );
}

export default ProfileLayout;
